function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M345.043,122.434h-66.783c0-12.294-9.967-22.261-22.261-22.261s-22.261,9.967-22.261,22.261h-66.783  c0,12.295,10.709,22.261,23.002,22.261h-0.741c0,12.295,9.966,22.261,22.261,22.261c0,12.295,9.966,22.261,22.261,22.261h44.522  c12.295,0,22.261-9.966,22.261-22.261c12.295,0,22.261-9.966,22.261-22.261h-0.741C334.335,144.695,345.043,134.728,345.043,122.434  z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg049Ecuador(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 256
  }), /*#__PURE__*/React.createElement("rect", {
    y: 256,
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 128.011
  }), /*#__PURE__*/React.createElement("rect", {
    y: 384.011,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 127.989
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDA44"
    },
    cx: 256,
    cy: 256,
    r: 89.043
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M256,311.651c-30.687,0-55.652-24.966-55.652-55.652v-33.391c0-30.687,24.966-55.652,55.652-55.652  s55.652,24.966,55.652,55.652v33.391C311.652,286.685,286.687,311.651,256,311.651z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg049Ecuador);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iMjU2Ii8+CjxyZWN0IHk9IjI1NiIgc3R5bGU9ImZpbGw6IzAwNTJCNDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iMTI4LjAxMSIvPgo8cmVjdCB5PSIzODQuMDExIiBzdHlsZT0iZmlsbDojRDgwMDI3OyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxMjcuOTg5Ii8+CjxjaXJjbGUgc3R5bGU9ImZpbGw6I0ZGREE0NDsiIGN4PSIyNTYiIGN5PSIyNTYiIHI9Ijg5LjA0MyIvPgo8cGF0aCBzdHlsZT0iZmlsbDojMzM4QUYzOyIgZD0iTTI1NiwzMTEuNjUxYy0zMC42ODcsMC01NS42NTItMjQuOTY2LTU1LjY1Mi01NS42NTJ2LTMzLjM5MWMwLTMwLjY4NywyNC45NjYtNTUuNjUyLDU1LjY1Mi01NS42NTIgIHM1NS42NTIsMjQuOTY2LDU1LjY1Miw1NS42NTJ2MzMuMzkxQzMxMS42NTIsMjg2LjY4NSwyODYuNjg3LDMxMS42NTEsMjU2LDMxMS42NTF6Ii8+CjxwYXRoIGQ9Ik0zNDUuMDQzLDEyMi40MzRoLTY2Ljc4M2MwLTEyLjI5NC05Ljk2Ny0yMi4yNjEtMjIuMjYxLTIyLjI2MXMtMjIuMjYxLDkuOTY3LTIyLjI2MSwyMi4yNjFoLTY2Ljc4MyAgYzAsMTIuMjk1LDEwLjcwOSwyMi4yNjEsMjMuMDAyLDIyLjI2MWgtMC43NDFjMCwxMi4yOTUsOS45NjYsMjIuMjYxLDIyLjI2MSwyMi4yNjFjMCwxMi4yOTUsOS45NjYsMjIuMjYxLDIyLjI2MSwyMi4yNjFoNDQuNTIyICBjMTIuMjk1LDAsMjIuMjYxLTkuOTY2LDIyLjI2MS0yMi4yNjFjMTIuMjk1LDAsMjIuMjYxLTkuOTY2LDIyLjI2MS0yMi4yNjFoLTAuNzQxQzMzNC4zMzUsMTQ0LjY5NSwzNDUuMDQzLDEzNC43MjgsMzQ1LjA0MywxMjIuNDM0ICB6Ii8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };